import { EndPoints } from "../../Constants/endpoints";

export const refetchAllAppointmentsApis = (queryClient: any) => {
  queryClient.refetchQueries({
    queryKey: [EndPoints.GetMyAppointments],
    exact: false,
  });
  queryClient.refetchQueries({
    queryKey: [EndPoints.GetAvailableScheduled],
    exact: false,
  });
  queryClient.refetchQueries({
    queryKey: [EndPoints.GetMonthAppointments],
    exact: false,
  });
  queryClient.refetchQueries({
    queryKey: [EndPoints.GetHomeAppointments],
    exact: false,
  });
  queryClient.refetchQueries({
    queryKey: [EndPoints.GetLastAppointmentForPatient],
    exact: false,
  });
  queryClient.refetchQueries({
    queryKey: [EndPoints.AppointmentDetails],
    exact: false,
  });
  queryClient.refetchQueries({
    queryKey: [EndPoints.GetMyPatient],
    exact: false,
  }); 
  queryClient.refetchQueries({
    queryKey: [EndPoints.Notifications],
    exact: false,
  });
  queryClient.refetchQueries({
    queryKey: [EndPoints.GetReminderAppointments],
    exact: false,
  });
};
